import request from '@/utils/request'
const url_prefix = process.env.VUE_APP_API_URL

// 商品详情
export function getGoodsDetail(data) {
  return request({
    url: `${url_prefix}/payment-api/list_subjects`,
    method: 'post',
    data
  })
}

// 创建订单
export function createTrade(data) {
  return request({
    url: `${url_prefix}/payment-api/create_trade`,
    method: 'post',
    data
  })
}

// 获取订单列表
export function getTradeList(data) {
  return request({
    url: `${url_prefix}/payment-api/list_orders`,
    method: 'post',
    data
  })
}

// 获取订单详情
export function getTradeDetail(data) {
  return request(
    {
      url: `${url_prefix}/payment-api/get_trade_detail`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 关闭支付订单
export function closePay(data) {
  return request(
    {
      url: `${url_prefix}/payment-api/close_pay`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 支付宝支付
export function payAli(data) {
  return request({
    url: `${url_prefix}/payment-api/payAli/pc`,
    method: 'post',
    data
  })
}

// 微信支付
export function payWechat(data) {
  return request({
    url: `${url_prefix}/payment-api/payWechat/pc`,
    method: 'post',
    data
  })
}

// 获取对话次数
export function getTryCounts() {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/non_member_try_info`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 查询我的客服信息
export function getCsInfo() {
  return request(
    {
      url: `${url_prefix}/payment-api/v1/cs/me`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 工单列表
export function getOrderFeedbackList(params) {
  return request(
    {
      url: `${url_prefix}/payment-api/v1/cs/my_orders`,
      method: 'get',
      params
    },
    {
      loading: false
    }
  )
}

// 查阅工单
export function readOrder(data) {
  return request(
    {
      url: `${url_prefix}/payment-api/v1/cs/order/read`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 开发票
export function invoice(data) {
  return request(
    {
      url: `${url_prefix}/payment-api/v1/invoice`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
